<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oN3W6H/tc-custom/9781455603442.jpg?1738389448521" alt="This image is the cover for the book Den of Misery"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Den of Misery
      </h1>
      <p class="bookDescription body article font2">
        <p>"Shines the harsh light of truth on a forgotten--and whitewashed--chapter of American history. Graphic and sometimesappalling, James R. Hall's account of conditions at Indianapolis's Camp Morton is necessary reading for anyone who prefers genuine history to the sanitized version."--Brian D. Smith, member, Pulitzer Prize-winning reporting team, Fort Wayne News-Sentinel , 1983</p><p>The term"prison abuse scandal" has become a familiar phrase in our lifetime. But long before this phrase was used on the nightly news, truths about the treatment of enemy prisoners were defiantly denied, and the media-whose primary sources (much like today) were politicians and military officials-inevitably distorted the facts.</p><p>In the case of Camp Morton, however, records exist from the firsthand accounts of prisoners, who were extremely vocal about their experiences after the Civil War ended. Confederate veterans who had been held at Camp Morton and heard that prominent Union officials were calling it a"model" Civil War prison were enraged and inspired to proclaim the truth about their suffering. Their experiences first were revealed publicly by former Morton prisoner, prominent physician, and medical researcher Dr. John A. Wyeth. James R. Hall has picked up where Dr. Wyeth left off, making the Camp Morton controversy known to a new generation.</p><p>Den of Misery: Indiana's Civil War Prison details the cover-ups and denials as well as the cruel realities of the prison camp and chronicles the efforts by Confederate veterans to make known the truth about their experiences. The author includes a full list of prisoners who died at Camp Morton and are buried in a mass grave in Indianapolis.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James R. Hall
      </h2>
      
      <p class="authorDescription body article">James R. Hall was a freelance writer and pastoral counselor. He lived in Shelbyville, Indiana, with his wife, a son, and their dachshunds, Maxie and Sammy. He passed away in August of 2013.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pelican Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?44e3346e